<template>
  <span
    class="current-class"
    data-cy="current-class-name"
    >{{ currentClassName }}</span
  >
</template>

<script setup lang="ts">
import { useMe } from '@/graphql/queries';

const { currentClassName } = useMe();
</script>

<style scoped lang="scss">
@import '@/styles/_variables.scss';
@import '@/styles/_mixins.scss';

.current-class {
  display: flex;
  flex-direction: column;
  align-self: center;
  line-height: 1;
  @include regular-text;
}
</style>
